<template>
  <TraitRanksFilters>
    <TraitRanksApesTraitsFiltersSearch @search="$emit('search', $event)" />
    <FilterItem
      v-model:isOpen="filterOpen['gender']"
      :filter="genderFilter"
      :selected-traits="activeGender"
      :show-search="false"
      @update:value="$emit('update:gender', $event)"
    />
    <!-- <FilterItem
            v-model:isOpen="filterOpen['rarity']"
            :filter="rarityFilter"
            :selected-traits="activeRarity"
            :show-search="false"
            @update:value="$emit('update:rarity', $event)"
        /> -->

    <FilterItem
      v-model:isOpen="filterOpen['categories']"
      :filter="categoryFilter"
      :selected-traits="activeCategories"
      @update:value="$emit('update:categories', $event)"
    />
  </TraitRanksFilters>
</template>
<script>
import { computed, defineComponent, ref } from "vue"
import TraitRanksFilters from "./TraitRanksFilters.vue"
import GalleryFiltersSearch from "../GalleryFiltersSearch.vue"
import FilterItem from "../FilterItem.vue"
import { useApiGetApeCategories } from "@/api/apes/get-categories"
import TraitRanksApesTraitsFiltersSearch from "../TraitRanksApesTraits/TraitRanksApesTraitsFiltersSearch.vue"
export default defineComponent({
    components: { FilterItem, TraitRanksApesTraitsFiltersSearch, TraitRanksFilters, GalleryFiltersSearch },
    props: {
        gender: Number,
        categories: {
            type: Array,
            default: () => []
        },
        rarity: String
    },
    setup(props, { emit }) {
        const filterOpen = ref({
            gender: true,
            categories: true,
            rarity: true
        })
        const genderFilter = {
            name: 'Gender',
            traits: [
                {
                    name: 'All'
                },
                {
                    name: 'Male'
                },
                {
                    name: 'Female'
                },
                {
                    name: 'Unisex'
                },

            ]
        }
        const rarityFilter = {
            name: 'Rarity',
            traits: [
                {
                    name: 'All'
                },
                {
                    name: 'Legendary'
                },
                {
                    name: 'Epic'
                },
                {
                    name: 'Common'
                },

            ]
        }
        const activeRarity = computed(() => {
            if (!props.rarity) return [
                {
                    name: "Rarity",
                    trait: "All",
                    active: true
                }
            ]
            return [
                {
                    name: "Rarity",
                    trait: props.rarity,
                    active: true
                }
            ]
        })


        const categoryFilter = ref({
            name: "Category",
            traits: [

            ]
        })
        const activeGender = computed(() => {
            if (!props.gender) {
                return [
                    {
                        name: "Gender",
                        trait: "All",
                        active: true
                    }
                ]
            }
            if (props.gender === 1) {
                return [
                    {
                        name: "Gender",
                        trait: "Male",
                        active: true
                    }
                ]
            }
            if (props.gender === 2) {
                return [
                    {
                        name: "Gender",
                        trait: "Female",
                        active: true
                    }
                ]
            }
            if (props.gender === 3) {
                return [
                    {
                        name: "Gender",
                        trait: "Unisex",
                        active: true
                    }
                ]
            }

            return []
        })
        const fetchCategories = async () => {
            let categories = await useApiGetApeCategories({
                toast: { error: true },
            }).exec();
            categoryFilter.value.traits = categories
        }
        fetchCategories()
        const activeCategories = computed(() => {
            return props.categories.map(cat => ({
                name: "Category",
                active: true,
                trait: cat.name
            }))
        })
        return { filterOpen, activeRarity, rarityFilter, activeGender, activeCategories, categoryFilter, genderFilter }
    }
})
</script>
<style lang="scss"></style>